import { ReactNode } from 'react';
import { TextBlock } from '../../../Atoms/Text';

interface ScorerNoticeProps {
  icon: ReactNode;
  title: string;
  children?: ReactNode;
}

/** A message shown in place of the scoring form: the confirmation, or why the link can't be used. */
export const ScorerNotice = ({ icon, title, children }: ScorerNoticeProps) => (
  <section className="flex flex-col items-center gap-3 rounded-lg bg-white px-6 py-12 text-center">
    {icon}
    <TextBlock
      size="lg"
      weight="semibold"
      color="grey8">
      {title}
    </TextBlock>
    {children}
  </section>
);
